export default __webpack_public_path__ + "static/media/ManagePatientProfile.109f31fc.svg";